'use strict';

/*global K2ApplicationSpecial*/
/*global services*/
/*global mekrsSetting*/
/*global reloadQueuePage*/
/*global fingerprint*/
/*global fingerprintData*/

var app = null;

function initialize($wrapper) {
  $wrapper.find('.reload-page-countdown').k2_countdown({ duration: app.param('reload_page_interval'), callback: reloadQueuePage, repeat: true });
  $wrapper.find('.alert-fs').k2_alerts({ autoCloseTimeout: app.param('alert_auto_close_timeout') });
  $wrapper.find('.lookup').k2_lookup({ searchEmptyString: false });
  $wrapper.find('.help-box').k2_helpBox();
  $wrapper.find('.form-clear-filter').k2_filterClear();
  $wrapper.find('.table-fixed-hover').k2_tableFixedHover();
  $wrapper.find('.checkboxes-toggler').k2_checkboxesToggler();
  $wrapper.find('.panel-collapsible').k2_panelCollapsible();
  $wrapper.find('.k2-keyboard-input').k2_keyboard_input();
  $wrapper.find('.k2-keyboard-input--lazy-open').k2_keyboard_input({ openAfterFocus: false, customButtons: mekrsSetting.keyboardCustomButtons });
  $wrapper.find('.autofocus').k2_autofocus();
}

/*exported getResolution*/
function getResolution() {
  try {
    var message = 'Your screen resolution is: ' + window.screen.width * window.devicePixelRatio + 'x' + window.screen.height * window.devicePixelRatio + ' (' + window.screen.width + 'x' + window.screen.height + ' | ' + window.devicePixelRatio + ')';
    alert(message);
    $('body').append(message);
  } catch (e) {
    alert(e.message);
    $('body').append(e.message);
  }
}

/*exported testFunction*/
function testFunction() {
  alert('Test funkce');
  app.internetConnectionManager.viewOfflineWarning();
}

/*exported testModals*/
function testModals() {
  var $modalsCount = $('<div class="modals-count">');
  $('body').append($modalsCount);

  var lastValue = 0;
  setInterval(function () {
    var totalCount = $('body').find('.modal').length;
    var visibleCount = $('body').find('.modal:visible').length;
    var inCount = $('body').find('.modal.in').length;

    $modalsCount.html('<span>' + totalCount + '</span><span>' + visibleCount + '</span><span>' + inCount + '</span><span>' + lastValue + '</span>');

    lastValue = ++lastValue % 2;
  }, 1000);

  $modalsCount.on('click', function () {
    $('body').find('.modal:not(.in):visible').hide();
  });
}

function testFingerprint() {
  if (!$('#login-form').length) {
    return;
  }

  var $fingerprint = $('<div class="fingerprint">');
  $('body').append($fingerprint);

  var html = '';
  html += '<h3>Cookies</h3>';
  html += '<div>' + services.get('cookies').get('fingerprint') + '</div>';
  html += '<div>' + services.get('cookies').get('fingerprint_data') + '</div>';

  html += '<h3>Current data</h3>';
  html += '<div>' + fingerprint() + '</div>';
  html += '<div>' + JSON.stringify(fingerprintData().source) + '</div>';

  html += '<h3>Device settings</h3>';
  html += '<div>screen.width = ' + screen.width + '</div>';
  html += '<div>screen.height = ' + screen.height + '</div>';
  html += '<div>window.innerWidth = ' + window.innerWidth + '</div>';
  html += '<div>window.devicePixelRatio = ' + window.devicePixelRatio + '</div>';
  html += '<div>getComputedStyle(document.documentElement).fontSize = ' + getComputedStyle(document.documentElement).fontSize + '</div>';

  $fingerprint.append(html);

  $fingerprint.on('click', function () {
    app.showMessageHtml($fingerprint.html());
  });
}

$(document).ready(function () {
  app = new K2ApplicationSpecial(services);

  initialize($('body'));

  $('body').k2_onscreenInput({
    afterChange: function (input) {
      input.trigger('keyup');
    }
  });

  $().k2_top();

  if (!services.get('cookies').get('fingerprint')) {
    services.get('cookies').set('fingerprint', fingerprint(), 24 * 60 * 60 * 1000);
  }

  if (!services.get('cookies').get('fingerprint_data')) {
    services.get('cookies').set('fingerprint', fingerprint(), 24 * 60 * 60 * 1000);
    services.get('cookies').set('fingerprint_data', JSON.stringify(fingerprintData().source), 24 * 60 * 60 * 1000);
  }

  testModals();
  testFingerprint();
});
